import { render } from "./MigrationConsentBanner.vue?vue&type=template&id=3634adb8"
import script from "./MigrationConsentBanner.vue?vue&type=script&lang=js"
export * from "./MigrationConsentBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__